import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import color from '../../../constants/color';
import icons from '../../../constants/icons';
import {
  Button,
  CardForm,
  CardFormBody,
  ContainerForm,
  ContainerInfoImage,
  ContainerInfoImageHeader,
  FooterBotton,
  Img,
  Info,
  LoadingSize,
  MarginLeft,
  OnPress,
  PageNumber,
  SizedBox,
  SizedBoxMultple,
  Space,
  TextButton,
} from './styles';
import InputFileCommon from '../../../components/inputFileCommon';
import InputCommon from '../../../components/inputCommon';
import Instructions from '../component/instructions';
import RowInputCustom from '../component/rowInputs';
import { Criterios, GenericPlace } from '../../../interfaces';
import ListItemCommon from '../../../components/itemListCommon';
import ItemCard from '../../../components/itemCardCommon';
import warn from '../../../constants/toast';
import axios from '../../../services/poleposition';
import imagem from '../../../utils/imagen';

interface Props {
  tipoPolePosition: number;
  goInit: Function;
  place?: Array<GenericPlace>;
  criterion?: Array<Criterios>;
}

const ForPosition: React.FC<Props> = ({
  goInit, place, criterion, tipoPolePosition,
}) => {
  const toPush = { colocacaoInicial: '0', colocacaoFinal: '0', quantidadePosicoes: '0' };
  const [benefitInput, setBenefitInput] = useState<Array<any>>([
    { colocacaoInicial: '0', colocacaoFinal: '0', quantidadePosicoes: '0' },
  ]);
  const [photoBase64, setPhotoBase64] = useState<string>('');
  const [fileName, setNameFile] = useState<string>('');
  const [photoError, setPhotoError] = useState<boolean>(false);
  const [PoleNameError, setLocalNameError] = useState<boolean>(false);
  const [PoleName, setLocalName] = useState<string>('');
  const [hasPhoto, setHasPhoto] = useState<boolean>(false);
  const [isSelectImg, setIsSelectImg] = useState(true);
  const [isBenefitsPosition, setIsBenefitsPosition] = useState<boolean>(false);
  const [isPlace, setIsPlace] = useState<boolean>(false);
  const [isDiscretion, setIsDiscretion] = useState<boolean>(false);
  const [isEnd, setIsEnd] = useState<boolean>(false);
  const [places, setPlaces] = useState<Array<GenericPlace>>([]);
  const [criterions, setCriterions] = useState<Array<Criterios>>([]);
  const [message, setMessage] = useState<string>('');
  const [messageError, setMessageError] = useState<boolean>(false);
  const [loadingSave, setLoadingSave] = useState<boolean>(false);

  useEffect(() => {
    setPlaces(place?.map((item) => ({
      ...item,
      check: false,
    })) || []);
    setCriterions(criterion?.map((item) => ({
      ...item,
      check: false,
    })) || []);
  }, []);

  useEffect(() => {
    if (PoleName && PoleNameError) {
      setLocalNameError(false);
    }
    if (photoBase64 && photoError) {
      setPhotoError(false);
    }
    if (message && messageError) {
      setMessageError(false);
    }
  }, [fileName, PoleName, message]);

  const onChangeFrom = (value: any, index: string) => {
    if (value === '' || value >= '0') {
      setBenefitInput(benefitInput.map((item, it: number) => {
        if (it.toString() === index) {
          item.colocacaoInicial = value;
          return item;
        }
        return item;
      }));
    }
  };
  const onChangeTo = (value: any, index: string) => {
    if (value === '' || value >= '0') {
      setBenefitInput(benefitInput.map((item, it: number) => {
        if (it.toString() === index) {
          item.colocacaoFinal = value;
          return item;
        }
        return item;
      }));
    }
  };

  const onChangeEnd = (value: any, index: string) => {
    if (value === '' || value >= '0') {
      setBenefitInput(benefitInput.map((item, it: number) => {
        if (it.toString() === index) {
          item.quantidadePosicoes = value;
          return item;
        }
        return item;
      }));
    }
  };

  const remove = (key: string) => {
    if (benefitInput.length === 1) {
      return;
    }
    setBenefitInput(benefitInput.filter((item: any, index: number) => index.toString() !== key));
  };

  function validation() {
    let to = false;
    for (let a = 0; a < benefitInput.length; a += 1) {
      if (benefitInput[a].colocacaoInicial === '0' || benefitInput[a].colocacaoFinal === '0' || benefitInput[a].quantidadePosicoes === '0') {
        to = true;
        break;
      }
    }

    if (!message) {
      setMessageError(true);
      return warn.wargingAlert('Informe a mensagem!');
    }
    if (to) {
      return warn.wargingAlert(`Informe a(s) vantagem(s)!${!message ? ', Informe a mensagem!' : ''}`);
    }

    setIsBenefitsPosition(false);
    setIsPlace(true);
    return false;
  }

  const savePolePosition = async () => {
    try {
      setLoadingSave(true);
      await axios.SavePolepostion(
        PoleName,
        fileName,
        message,
        imagem.filterImg(photoBase64) || '',
        criterions || [],
        places,
        benefitInput,
        tipoPolePosition,
      );
      setIsDiscretion(false);
      setIsEnd(true);
    } catch (error: any) {
      setLoadingSave(false);
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const cleanState = () => {
    setLocalName('');
    setNameFile('');
    setPhotoBase64('');
    setMessage('');
    setPlaces(place || []);
    setCriterions(criterion || []);
  };

  const uploadImageView = () => (
    <CardForm>
      <CardFormBody color="#FFF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <Img
              src={icons.arrowLeftBlueIcon}
              style={{ marginRight: 6 }}
              height={8}
              width={6}
            />
            <TextButton onClick={() => {
              goInit();
              setIsSelectImg(false);
            }}
            >
              VOLTAR
            </TextButton>
          </ContainerInfoImageHeader>
          <MarginLeft>
            <Instructions
              imageTop={icons.libraryIcon}
              title="Incluir nome e foto"
              subTitle={`Inclua uma foto que combine com o pole${'\n'}
              position e escolha um nome adequado.${'\n'}`}
              phase={1}
            />
          </MarginLeft>
        </ContainerInfoImage>
      </CardFormBody>
      <CardFormBody color="#E0E9FF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <PageNumber>01</PageNumber>
            <Info style={{ color: color.VivazBlack }}>Incluir nome e foto</Info>
          </ContainerInfoImageHeader>
          <SizedBoxMultple />
          <MarginLeft>
            <InputFileCommon
              hasPhoto={hasPhoto}
              setHasPhoto={setHasPhoto}
              onChange={setPhotoBase64}
              onChangeFileName={setNameFile}
              photo={photoBase64}
              isError={photoError}
            />
            <Space />
            <Space />
            <InputCommon
              isDisabled={false}
              isError={PoleNameError}
              type="text"
              placeholder="Nome"
              value={PoleName}
              onChange={setLocalName}
            />
            <SizedBoxMultple />
            <FooterBotton>
              <Button
                onClick={() => {
                  if (!PoleName) {
                    setLocalNameError(true);
                    return toast.warning('Atenção, infome o nome do local.', {
                      style: {
                        backgroundColor: 'orange',
                      },
                    });
                  }
                  setLocalNameError(false);
                  setPhotoError(false);
                  setIsSelectImg(false);
                  setIsBenefitsPosition(true);
                  return true;
                }}
                variant="contained"
                color="primary"
              >
                AVANÇAR
              </Button>
            </FooterBotton>
          </MarginLeft>
        </ContainerInfoImage>
        <Space />
      </CardFormBody>
    </CardForm>
  );
  const benefitsToPosition = () => (
    <CardForm>
      <CardFormBody color="#FFF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <Img
              src={icons.arrowLeftBlueIcon}
              style={{ marginRight: 6 }}
              height={8}
              width={6}
            />
            <TextButton onClick={() => {
              setIsSelectImg(true);
              setIsBenefitsPosition(false);
            }}
            >
              VOLTAR
            </TextButton>
          </ContainerInfoImageHeader>
          <MarginLeft>
            <Instructions
              imageTop={icons.benefitIcon}
              title="Vantagens por posição"
              subTitle={`Escolha quantas posições os corretores vão${'\n'}
              reseber de acordo com suas${'\n'}posições no Ranking`}
              phase={2}
            />
          </MarginLeft>
        </ContainerInfoImage>
      </CardFormBody>
      <CardFormBody color="#E0E9FF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <PageNumber>02</PageNumber>
            <Info style={{ color: color.VivazBlack }}>Vantagens por posição</Info>
          </ContainerInfoImageHeader>
          <SizedBoxMultple />
          <MarginLeft>
            <InputCommon
              isDisabled={false}
              isError={messageError}
              type="text"
              multiline
              row={3}
              placeholder="Mensagem para o corretor"
              value={message}
              onChange={setMessage}
            />
            <Space />
            {benefitInput.map((item: any, index: number) => (
              <>
                <Space />
                <RowInputCustom
                  id={index.toString()}
                  remove={remove}
                  onChangeFrom={onChangeFrom}
                  onChangeTo={onChangeTo}
                  onChangeEnd={onChangeEnd}
                  from={item.colocacaoInicial}
                  to={item.colocacaoFinal}
                  end={item.quantidadePosicoes}
                />
              </>
            ))}
            <SizedBox />
            <OnPress onClick={() => {
              setBenefitInput((state) => [...state, toPush]);
            }}
            >
              <Img
                height={24}
                width={24}
                src={icons.plusGreenIcon}
              />
            </OnPress>
            <Space style={{ marginTop: 8 }} />
            <SizedBox />
            <FooterBotton>
              <Button
                onClick={() => {
                  validation();
                }}
                variant="contained"
                color="primary"
              >
                AVANÇAR
              </Button>
            </FooterBotton>
          </MarginLeft>
        </ContainerInfoImage>
        <Space />
      </CardFormBody>
    </CardForm>
  );

  const selectPlace = () => (
    <CardForm>
      <CardFormBody color="#FFF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <Img
              src={icons.arrowLeftBlueIcon}
              style={{ marginRight: 6 }}
              height={8}
              width={6}
            />
            <TextButton onClick={() => {
              setIsPlace(false);
              setIsBenefitsPosition(true);
            }}
            >
              VOLTAR
            </TextButton>
          </ContainerInfoImageHeader>
          <MarginLeft>
            <Instructions
              imageTop={icons.pinIcon}
              title="Locais do pole position"
              subTitle="Escolha os locais que farão parte deste pole position"
              phase={3}
            />
          </MarginLeft>
        </ContainerInfoImage>
      </CardFormBody>
      <CardFormBody color="#E0E9FF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <PageNumber>03</PageNumber>
            <Info style={{ color: color.VivazBlack }}>Escolha os locais </Info>
          </ContainerInfoImageHeader>
          <SizedBoxMultple />
          <MarginLeft>
            {places?.map((item) => (
              <ListItemCommon
                onChange={(key: string) => {
                  setPlaces(places?.map((it) => {
                    if (it.idLocal === key) {
                      it.check = !it.check;
                      return it;
                    }
                    return it;
                  }));
                }}
                id={item.idLocal}
                check={item.check || false}
                photo={item.urlImagem}
                name={item.nome}
                isPhoto
              />
            ))}
            <Space style={{ marginTop: 8 }} />
            <SizedBoxMultple />
            <FooterBotton>
              <Button
                onClick={() => {
                  if (places.every((item) => item.check === false)) {
                    warn.wargingAlert('Informe o local!');
                  } else {
                    setIsPlace(false);
                    setIsDiscretion(true);
                  }
                }}
                variant="contained"
                color="primary"
              >
                AVANÇAR
              </Button>
            </FooterBotton>
          </MarginLeft>
        </ContainerInfoImage>
        <Space />
      </CardFormBody>
    </CardForm>
  );

  const selectDiscretion = () => (
    <CardForm>
      <CardFormBody color="#FFF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <Img
              src={icons.arrowLeftBlueIcon}
              style={{ marginRight: 6 }}
              height={8}
              width={6}
            />
            <TextButton onClick={() => {
              setIsPlace(true);
              setIsDiscretion(false);
            }}
            >
              VOLTAR
            </TextButton>
          </ContainerInfoImageHeader>
          <MarginLeft>
            <Instructions
              imageTop={icons.discretionIcon}
              title="Critérios do pole position"
              subTitle="Nesta etapa você irá personalizar quais critérios serão utilizados neste pole position"
              phase={4}
            />
          </MarginLeft>
        </ContainerInfoImage>
      </CardFormBody>
      <CardFormBody color="#E0E9FF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <PageNumber>04</PageNumber>
            <Info style={{ color: color.VivazBlack }}>Definição de critérios</Info>
          </ContainerInfoImageHeader>
          <SizedBoxMultple />
          <MarginLeft>
            {criterions?.map((item) => (
              <ListItemCommon
                onChange={(key: string) => {
                  setCriterions(criterions?.map((it) => {
                    if (it.idCriterio === key) {
                      it.check = !it.check;
                      return it;
                    }
                    return it;
                  }));
                }}
                id={item.idCriterio}
                check={item.check || false}
                name={item.nome}
                isPhoto={false}
              />
            ))}
            <Space style={{ marginTop: 8 }} />
            <FooterBotton>
              <Button
                disabled={loadingSave}
                onClick={() => {
                  if (criterions.every((item) => item.check === false)) {
                    warn.wargingAlert('Informe as definições de critério!');
                  } else {
                    savePolePosition();
                  }
                }}
                variant="contained"
                color="primary"
              >
                {loadingSave ? (
                  <LoadingSize size={18} />
                ) : 'FINALIZAR'}
              </Button>
            </FooterBotton>
          </MarginLeft>
        </ContainerInfoImage>
        <Space />
      </CardFormBody>
    </CardForm>
  );

  const endRegister = () => (
    <CardForm>
      <CardFormBody color="#FFF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader />
          <MarginLeft>
            <Instructions
              onClick={() => {
                cleanState();
                goInit(true);
                setIsEnd(false);
              }}
              imageTop={icons.checkEndIcon}
              title="Pole Position adicionado"
              subTitle="Parabéns, seu novo pole position foi cadastrado com sucesso"
              phase={5}
            />
          </MarginLeft>
        </ContainerInfoImage>
      </CardFormBody>
      <CardFormBody color="#E0E9FF">
        <ItemCard
          img={icons.noteIcon}
          title={PoleName}
          icon={icons.viewIcon}
          subTitle1="Modelo: Online"
          subTitle2=""
          subTitle3=""
          onClick={() => {
          }}
          id="0"
        />
      </CardFormBody>
    </CardForm>
  );

  return (
    <>
      <ContainerForm>
        {isSelectImg && uploadImageView()}
        {isBenefitsPosition && benefitsToPosition()}
        {isPlace && selectPlace()}
        {isDiscretion && selectDiscretion()}
        {isEnd && endRegister()}
      </ContainerForm>
    </>
  );
};

export default ForPosition;
